Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getAssetByID () {
        return _registry.getAssetByID;
    },
    get registerAsset () {
        return _registry.registerAsset;
    }
});
var _registry = require("@react-native/assets-registry/registry");
